import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import AccountBottomNavBar from "./AccountBottomNavBar";

export default function AccountLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("jwt");
    if (!token || token === "" || token === undefined || token === null) {
      navigate("/login");
      return;
    }
  }, []);

  return (
    <>
      <div style={{ paddingBottom: 80 }}>
        <Outlet />
      </div>
      <AccountBottomNavBar />
    </>
  );
}
